export default __webpack_public_path__ + "static/media/blockchain.f4969fc3.webp";